import { get, last } from "lodash";
import errorLogger from "../../utils/errorLogger";
import { GEO_HIERARCHY_LEVELS } from "../../utils/globals";

export const getLinkFromAddress = (topLevelDomain, hierarchyLevel, address, realEstateType) => {
  const urlSearchParams = new URLSearchParams();
  if (hierarchyLevel === GEO_HIERARCHY_LEVELS.address) {
    urlSearchParams.set('centerofsearchaddress', `${address.city};${address.zipcode};${address.street} ${address.houseNumber};;;${address.district || ''}`);
    urlSearchParams.set('geocoordinates', `${address.position.lat};${address.position.lng};1.0`);
  } else { // street
    urlSearchParams.set('centerofsearchaddress', `${address.city};${address.zipcode};${address.street};;;${address.district || ''}`);
    urlSearchParams.set('geocoordinates', `${address.position.lat};${address.position.lng};5.0`);
  }
  urlSearchParams.set('cmp_id', '10-051953');
  urlSearchParams.set('cmp_name', 'residential_resultlist_pricedevelopment');
  urlSearchParams.set('cmp_position', 'residential_atlas');
  urlSearchParams.set('cmp_creative', 'price_map_redirect');
  return `${topLevelDomain}/Suche/controller/executePriceInsights/radius?realestatetype=${realEstateTypePathMap[realEstateType]}&${urlSearchParams.toString()}`
}

export const loadLinkFromHierarchy = (shapeID, shapeServiceUrl, topLevelDomain, realEstateType) => {
  // use shape server for getting matching nextgen url
  const shapeServerUrl = `${shapeServiceUrl}/shape/${shapeID}?precisionReductionTolerance=1`;

  return fetch(shapeServerUrl).then((response) => {
    if (!response.ok) {
      errorLogger.log(new Error(`could not fetch shape from uri: ${shapeServerUrl}`));
      return {
        error: true,
        status: response.status,
      };
    }

    return response.json().then((json) => {
      // for cities and regions matchingNextgenHierarchyShapes was not set, but they have geopath which seems to work for them
      const matchingGeoId = getMatchingNextGenShapeResponse(json);
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.set('cmp_id', '10-051953');
      urlSearchParams.set('cmp_name', 'residential_resultlist_pricedevelopment');
      urlSearchParams.set('cmp_position', 'residential_atlas');
      urlSearchParams.set('cmp_creative', 'price_map_redirect');

      const hierarchicSearchUrl = `${topLevelDomain}/Suche/controller/executePriceInsights/region?realestatetype=${realEstateTypePathMap[realEstateType]}&geocodes=${matchingGeoId}&${urlSearchParams.toString()}`;
      return {
        error: false,
        status: response.status,
        hierarchicSearchUrl
      };
    });
  });
};

const getMatchingNextGenShapeResponse = (data) => {
  if (data.matchingNextgenHierarchyShapes) {
    // it seems to be better to take the last entry in matchingNextgenHierarchyShapes, not the first...
    return last(data.matchingNextgenHierarchyShapes).id;
  }
  return get(data, 'id');
};

export const realEstateTypePathMap = {
  APARTMENT_BUY: 'apartmentbuy',
  HOUSE_BUY: 'housebuy',
  APARTMENT_RENT: 'apartmentrent',
  HOUSE_RENT: 'houserent',
};
